<template>
  <AutoSuggestInput
    :id="id"
    ref="auto-suggest-input"
    v-model="currencyValue"
    :label="currencyLabel"
    eyebrow="true"
    dropdown="true"
    :as-results="asCurrencyList"
    :featured="asFeaturedCurrencyList"
    :clear-on-input="false"
    :default-item-index="asDefaultIndex"
    :featured-label="featuredLabel"
    :non-featured-label="nonFeaturedLabel"
    :clear-button-label="clearButtonLabel"
    :dropdown-button-open-label="dropdownButtonOpenLabel"
    :dropdown-button-close-label="dropdownButtonCloseLabel"
    :error-msg="errorMessage"
    :validators="[isCurrencyValidator]"
    @keyup_auto_suggest="keyup_auto_suggest"
    @click_button_auto_suggest="click_button_auto_suggest"
    @select_option_auto_suggest="select_option_auto_suggest"
    @reset_auto_suggest="reset_auto_suggest"
    @onChange="onChange"
  />
</template>

<script>
import AutoSuggestInput from '@/components/forms/autoSuggest/autoSuggestInput/AutoSuggestInput.vue';

export default {
  name: 'VsCurrencyList',
  expose: ['resetValue', 'setValue'],
  components: {
    AutoSuggestInput,
  },
  props: {
    id: { type: String, default: '' },
    currencyList: { type: Array, default: null },
    featuredCurrencyList: { type: Array, default: null },
    defaultValue: { type: String, default: '' },
    value: { type: String },
    currencyLabel: { type: String, default: '' },
    featuredLabel: { type: String, default: '' },
    nonFeaturedLabel: { type: String, default: '' },
    errorMessage: { type: String },
    clearButtonLabel: { type: String, default: '' },
    dropdownButtonOpenLabel: { type: String, default: '' },
    dropdownButtonCloseLabel: { type: String, default: '' },
  },
  data() {
    return {
      none: 'None',
      searchStr: '',
      currencySet: new Set(),
      defaultIndex: '',
    };
  },
  computed: {
    currencyValue: {
      get() {
        return this.currencyCode(this.value);
      },
      set(currencyValue) {
        this.$emit('input', currencyValue);
      },
    },
    asCurrencyList() {
      return this.getCurrencyList(this.searchStr);
    },
    asFeaturedCurrencyList() {
      return this.getFeaturedCurrencyList();
    },
    asDefaultIndex() {
      return this.defaultIndex;
    },
  },
  watch: {
    currencyValue() {
      this.$emit('update:currencyValue', this.currencyValue);
    },
  },
  created() {
    this.currencyList.forEach((currency) => {
      this.currencySet.add(currency.key);
    });
    if (
      this.defaultValue &&
      this.defaultValue !== this.none &&
      this.defaultValue.length > 1
    ) {
      const fullCurrencyList = this.featuredCurrencyList.concat(
        this.currencyList
          .filter((currency) => currency.key !== this.none)
          .map((currency) => currency.key)
      );
      for (let i = 0; i < fullCurrencyList.length; i++) {
        if (fullCurrencyList[i] === this.defaultValue) {
          this.defaultIndex = i + '';
          break;
        }
      }
    } else {
      this.defaultIndex = '';
    }
  },
  methods: {
    keyup_auto_suggest(searchStr) {
      this.searchStr = searchStr;
    },
    click_button_auto_suggest() {
      // console.log(event);
    },
    select_option_auto_suggest() {
      // console.log(event);
    },
    reset_auto_suggest() {
      this.searchStr = '';
    },
    getCurrencyList(searchStr) {
      return JSON.stringify(
        this.currencyList
          .filter((currency) => {
            return (
              currency.key !== this.none &&
              (!searchStr ||
                searchStr.length < 1 ||
                currency.value.toLowerCase().includes(searchStr.toLowerCase()))
            );
          })
          .sort((a, b) => {
            const hasSearchStrAtBeginning = (stringToSearch) => {
              const index = stringToSearch.toLowerCase().indexOf(searchStr);
              if (index === 0) return true;
              const char = stringToSearch.charAt(index - 1).toLowerCase();
              return !(char >= 'a' && char <= 'z');
            };
            const valA = hasSearchStrAtBeginning(a.value);
            const valB = hasSearchStrAtBeginning(b.value);
            return valA && valB ? 0 : valA ? -1 : 1;
          })
          .map((currency) => {
            const asCurrency = {};
            if (searchStr && searchStr.length > 0) {
              const searchStrL = searchStr.toLowerCase();
              let asDescription = '';
              let index = 0;
              let substrIndex = 0;
              while (index >= 0 && substrIndex < currency.value.length) {
                index = currency.value
                  .toLowerCase()
                  .indexOf(searchStrL, substrIndex);
                if (index >= 0) {
                  asDescription += currency.value.substring(substrIndex, index);
                  asDescription += '<span class="vs-search-result-match">';
                  asDescription += currency.value.substring(
                    index,
                    index + searchStr.length
                  );
                  asDescription += '</span>';
                  substrIndex = index + searchStr.length;
                }
              }
              asDescription += currency.value.substring(substrIndex);
              asCurrency.description = asDescription;
            } else {
              asCurrency.description = currency.value;
            }
            asCurrency.key = currency.key;
            return asCurrency;
          })
      );
    },
    getFeaturedCurrencyList() {
      return JSON.stringify(
        this.featuredCurrencyList.map((key) => {
          const asCurrency = {};
          asCurrency.description = this.currencyList.find(
            (currency) => currency.key === key
          ).value;
          asCurrency.key = key;
          return asCurrency;
        })
      );
    },
    resetValue() {
      this.searchStr = '';
      this.$refs['auto-suggest-input'].resetValue();
    },
    setValue(newValue) {
      this.searchStr = newValue;
      this.$refs['auto-suggest-input'].setValue(newValue);
    },
    currencyCode(value) {
      if (this.currencySet.has(value.substring(0, 3))) {
        return value.substring(0, 3);
      } else {
        return value;
      }
    },
    onChange(event) {
      this.valid = event;
      this.$emit('onChange');
    },
    isCurrencyValidator(value) {
      const expression = /^([a-zA-Z]){3}$/;
      if (expression.test(value)) {
        const isFeatured =
          this.featuredLabel &&
          this.nonFeaturedLabel &&
          JSON.parse(this.asFeaturedCurrencyList).length;
        const resultsArray = isFeatured
          ? JSON.parse(this.asFeaturedCurrencyList).concat(
              JSON.parse(this.asCurrencyList)
            )
          : JSON.parse(this.asCurrencyList);
        return resultsArray?.find((val) => val.key === value.toUpperCase());
      }
      return false;
    },
  },
};
</script>

<style>
span.vs-search-result-match {
  font-weight: bold;
}
</style>
